{
  "de": {
    "aiConverter": {
      "alerts": {
        "dialog": {
          "format": "Bitte kennzeichne die beiden Sprecher mit **Name**: am Zeilenanfang."
        },
        "example": "Möchtest du ein Beispiel?",
        "truncatedText": "Deine Quelle übersteigt das Limit von {limit} Zeichen und kann daher nicht in voller Länge verarbeitet werden."
      },
      "buttons": {
        "reuse": "Weiterverwenden",
        "transform": "Umwandeln",
        "limitReached": "Limit erreicht",
        "submitForKind": {
          "audio": "Text vorlesen lassen",
          "dialog": "Dialog erstellen",
          "lecture": "Impulsvortrag anlegen",
          "podcast": "Podcast anlegen",
          "summary": "Zusammenfassung anlegen",
          "text": "Text aus Bild oder Datei erkennen",
          "transcript": "Transkript anlegen",
          "translation": "Textübersetzung"
        }
      },
      "confirm": {
        "deleteDocument": {
          "text": "Diese Aktion kann nicht rückgängig gemacht werden. Das Dokument wird dauerhaft aus deinem Verlauf entfernt.",
          "title": "Dokument löschen?"
        }
      },
      "example": {
        "audio": {
          "text": "Elefanten leben in Herden. Dazu gehören aber nur Kühe und Jungtiere, keine erwachsenen Bullen. So eine Herde wird von einer erfahrenen Elefanten-Kuh angeführt. Die Kuh beschützt die Gruppe, indem sie zeigt, dass sie notfalls auch angreifen würde: Sie breitet ihre Ohren weit aus und erhebt den Rüssel hoch. Die ausgewachsenen Bullen leben meistens allein oder in Gruppen, die sich immer wieder auflösen und neu zusammensetzen. Nur zur Paarung nähern sie sich den Herden der Kühe. Elefanten ernähren sich rein vegetarisch. Am liebsten fressen sie Gras und Blätter, sonst aber auch Äste und andere Pflanzen. Sie brauchen täglich etwa 200 Kilogramm davon. Dazu trinken sie über 100 Liter Wasser. Elefanten schlafen weniger lang als Menschen. Sie brauchen die ganze Zeit, um zu fressen. Dazu müssen sie auch sehr weit laufen. Sie sind zwar langsam, aber sehr ausdauernd. Deshalb ist es schwierig, Elefanten in einem Zoo zu halten, weil es dort für sie schnell zu eng ist. Bei großer Hitze und um ihre Haut zu pflegen nehmen sie auch gerne mal ein Bad oder sie spritzen sich mit dem Rüssel Wasser über den Rücken. Bei Hitze fächeln sie mit ihren Ohren und können sich so etwas Kühlung verschaffen. (Quelle: https://klexikon.zum.de/wiki/Elefanten)"
        },
        "dialog": {
          "dialog": "Gib hier deinen Dialog ein, indem du die Sprecher*innen mit **Name/Rolle**: am Zeilenanfang kennzeichnest.",
          "text": "**Host**: Hallo! Wie heißt du?\n**Guest**: Ich heiße Anna. Und du?\n**Host**: Ich heiße Max. Schön, dich kennenzulernen.\n**Guest**: Ich freue mich auch."
        },
        "lecture": {
          "prompt": "Konzentriere dich auf die Geschichte und den politischen Hintergrund der Ukraine und erkläre das Thema passend für Schüler*innen der Klassenstufe 11",
          "url": "https://de.wikipedia.org/wiki/Ukraine"
        },
        "podcast": {
          "prompt": "Achte auf einfache Sprache für Lernende auf dem Sprachniveau A2. Fokussiere dich auf die Lebenswelt von Jugendlichen (12-14 Jahre) und gib für sie relevante Beispiele an.",
          "url": "https://thewanderbug.com/itinerary-5-days-new-york-city-first-time/"
        },
        "summary": {
          "url": "https://www.bpb.de/kurz-knapp/hintergrund-aktuell/559432/desinformation-und-wahlen/",
          "prompt": "Konzentriere dich auf die wichtigsten Fakten für Schüler*innen der Klassenstufe 10"
        },
        "transcript": {
          "url": "https://www.youtube.com/watch?v=hv0Hz2XMGXA"
        },
        "translation": {
          "text": "Most of us think of penguins as being a polar species, more at home on the ice of Antarctica than the sandy beaches, grassy fields and hills of the Falklands. But these incredible islands in the South Atlantic are home to five species of these fantastic flightless birds. The Falklands’ sandy shores are home to the largest population of gentoo penguins in the world – more than 121,000 pairs were counted here during the last census in 2010! Living on the Falklands all year round, the 76-cm-tall birds are easy to recognise because of the white bar that stretches across the top of their heads, and their bright orange bills. Super-fast in the sea, they swim at up to 36kmph as they dive for fish. Then, when it’s time for them to return to land, they ride the breakers before stumbling onto the beach. Back in 1971 there were just 31 breeding pairs of king penguins at Volunteer Green on East Falkland island, but today there are more than 1,500 – it’s the second-largest and most accessible colony of king penguins in the world. Fortunately, that’s where we’re visiting! Thousands of the metre-tall kings are standing together, their young close by at various stages of development. Some adults have pear-shaped white eggs resting on their feet, others have newborn grey chicks nestled between their belly feathers. Older chicks have grown their brown fluffy down, which looks a bit like sheep’s wool. We listen to the raucous call of the adults as they point their bills to the sky and trumpet, advertising their presence. It’s as if the upright, elegant adults are posing for photos, their beautiful orange-yellow necks and bills glowing in the sunshine. Source: https://www.natgeokids.com/uk/discover/animals/birds/penguins-of-the-falkland-islands/"
        }
      },
      "headings": {
        "config": "Welche Inhalte soll die KI verwenden?",
        "input": "Was soll die KI für dich erledigen?",
        "output": "Ergebnis"
      },
      "help": {
        "website": "Beispiel: https://fobizz.com/was-ist-fobizz/"
      },
      "hints": {
        "audio": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen. Wir unterstützen .mp3, .mp4, .mp4a oder .wav Dateien bis max. {limit}MB.",
        "copyright": "Hinweis: Achte darauf, dass bei deiner Nutzung fremder Inhalte die Urheberrechte gewahrt werden.",
        "image": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen. Wir unterstützen .jpeg, .png bis zu {limit}MB.",
        "materialGeneration": "Material wird erstellt...",
        "noInputKindSelected": "Bitte wähle eine Eingabeart aus.",
        "pdf": "Lade ein unterstütztes Dokument bis {limit}MB hoch: PDF, Word, PowerPoint, Excel, OpenDocument, Text, Markdown, CSV oder HTML.",
        "processingProgressMessage": "Text wird in Audio umgewandelt...",
        "submitting": "Umwandlung in Arbeit",
        "text": "Tipp: Sie können bis zu 5000 Zeichen eingeben.",
        "video": "Tipp: Du kannst eine Datei per Drag & Drop direkt hochladen. Wir unterstützen .mp4, .mp4v, .avi or .mkv Dateien bis max. 100MB."
      },
      "labels": {
        "additionalInfo": "Zusatzinfos und Zielgruppe",
        "dialog": "Dialogeingabe",
        "language": "Sprache",
        "outputLanguage": "Ausgabesprache",
        "outputText": "Ausgabetext",
        "source": "Quelle",
        "text": "Texteingabe",
        "transcript": "Transkript",
        "url": "URL",
        "voice": "Stimme",
        "voicePlural": "Stimmen",
        "secondVoice": "Zweite Stimme"
      },
      "links": {
        "download": "Herunterladen",
        "openInChat": "Im KI Chat öffnen"
      },
      "materialExports": {
        "assistant": "KI-Assistent",
        "classroom_screen": "Digitale Tafel",
        "pinboard": "Pinnwand",
        "survey": "Umfrage",
        "text_document": "Textdokument",
        "web_page": "Webseite",
        "worksheet": "Arbeitsblatt"
      },
      "sourceKinds": {
        "audio": "Audio",
        "dialog": "Dialog",
        "lecture": "Impulsvortrag",
        "podcast": "Podcast",
        "summary": "Zusammenfassung",
        "text": "Text",
        "transcript": "Transkript",
        "translation": "Übersetzung"
      },
      "options": {
        "inputKinds": {
          "audio": {
            "icon": "bi-file-music",
            "title": "Audiodatei"
          },
          "image": {
            "icon": "bi-file-image",
            "title": "Bild"
          },
          "pdf": {
            "icon": "bi-file-earmark-text",
            "title": "Datei"
          },
          "text": {
            "icon": "bi-file-text",
            "title": "Text"
          },
          "video": {
            "icon": "bi-film",
            "title": "Video Datei"
          },
          "website": {
            "icon": "bi-globe",
            "title": "Webseite"
          },
          "youtube": {
            "icon": "bi-youtube",
            "title": "YouTube"
          }
        },
        "languages": {
          "auto": "Automatisch erkennen"
        }
      },
      "paragraphs": {
        "voiceDefaultText": "Hallo, wie geht es dir? Ich bin dein fobizz KI-Assistent."
      },
      "placeholders": {
        "additionalInfo": "Ergänze Infos zur Zielgruppe und hebe inhaltliche Aspekte hervor, die dir besonders wichtig sind.",
        "website": "Webseiten URL eingeben..."
      },
      "statusMessages": {
        "combine_audio_chunks": "Audiodatei wird erstellt {progress}%",
        "extract_text": "Text wird extrahiert...",
        "generate_audio_file": "Audio wird erstellt {progress}%",
        "generate_dialog": "Dialog wird eingesprochen {progress}%",
        "generate_lecture": "Impulsvortrag wird erstellt...",
        "generate_podcast": "Podcast wird erstellt...",
        "processing_text_chunks": "Textabschnitte werden verarbeitet {progress}%",
        "summarize_text": "Text wird zusammengefasst...",
        "translate_text": "Text wird übersetzt...",
        "video_downloading": "Video wird heruntergeladen {progress}%",
        "video_processing": "Video wird verarbeitet {progress}%"
      }
    }
  }
}
